import axios from 'axios';
import { baseUrl } from '../../_api';
import {
  CREATE_POST_FAIL,
  CREATE_POST_REQUEST,
  CREATE_POST_SUCCESS,
  GET_POST_FAIL,
  GET_POST_REQUEST,
  GET_POST_SUCCESS,
  GET_SINGLE_POST_FAIL,
  GET_SINGLE_POST_REQUEST,
  GET_SINGLE_POST_SUCCESS,
} from './actionType';

export const _AddPost = (blogObj, adminID) => async (dispatch) => {
  dispatch({ type: CREATE_POST_REQUEST });
  await axios
    .post(`${baseUrl}/api/blog/add-post/${adminID}`, blogObj)
    .then((res) => {
      dispatch({ type: CREATE_POST_SUCCESS, payload: res.data });
    })
    .catch((err) => {
      console.log(err.response.data);
      dispatch({ type: CREATE_POST_FAIL, payload: err.response.data });
    });
};

export const _GetPost = () => (dispatch) => {
  dispatch({ type: GET_POST_REQUEST });
  axios
    .get(`${baseUrl}/api/blog/get-posts`)
    .then((res) => {
      dispatch({ type: GET_POST_SUCCESS, payload: res.data });
    })
    .catch((err) => {
      dispatch({ type: GET_POST_FAIL, payload: err.response.data });
    });
};

export const _GetSinglePost = (id) => (dispatch) => {
  dispatch({ type: GET_SINGLE_POST_REQUEST });
  axios
    .get(`${baseUrl}/api/blog/singlepost/${id}`, id)
    .then((res) =>
      dispatch({ type: GET_SINGLE_POST_SUCCESS, payload: res.data })
    )
    .catch((err) => {
      console.log(err.response.data);
      dispatch({ type: GET_SINGLE_POST_FAIL, payload: err.response.data });
    });
};
